import { api } from "./axios";
import type { User } from "../types";

export interface UserCreate {
  username: string;
  password: string;
  email?: string;
  role: "admin" | "user";
  is_active?: boolean;
  can_manage_users?: boolean;
  can_manage_devices?: boolean;
  can_access_config?: boolean;
  can_view_live?: boolean;
  can_view_recordings?: boolean;
  can_download_recordings?: boolean;
  assigned_device_ids?: number[];
}

export type UserUpdate = Partial<UserCreate>;

export async function listUsers(): Promise<User[]> {
  const r = await api.get("/users");
  return r.data;
}

export async function getUser(id: number): Promise<User> {
  const r = await api.get(`/users/${id}`);
  return r.data;
}

export async function createUser(data: UserCreate): Promise<User> {
  const r = await api.post("/users", data);
  return r.data;
}

export async function updateUser(id: number, data: UserUpdate): Promise<User> {
  const r = await api.patch(`/users/${id}`, data);
  return r.data;
}

export async function deleteUser(id: number) {
  await api.delete(`/users/${id}`);
}
